export {default} from './Avatar.connect';
